import script from "./ClassificationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassificationItem.vue?vue&type=script&setup=true&lang=js"

import "./ClassificationItem.vue?vue&type=style&index=0&id=c0fb59a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0fb59a2"]])

export default __exports__